<i18n src="@/lang/protocols.yaml"></i18n>

<template lang="pug">
.tab-pane.card-body
    h2.mb-4 {{ $t('tabs.download.title') }}

    .alert.alert-danger(v-if="commonGotchas.length")
        ul.mb-0
            li(v-for="gotcha in commonGotchas") {{ gotcha }}

    .row.d-flex.align-items-stretch
        .col.mb-4.mb-sm-0
            .card.h-100: .card-body
                p Sind alle Eingaben gemacht und beide Schutzziele erreicht, können Sie das Protokoll als PDF herunterladen:
                button.btn.btn-primary.mr-2(@click="openPDF(value)")
                    font-awesome-icon.mr-1(icon="external-link-alt")
                    | PDF öffnen
                button.btn.btn-primary(@click="downloadPDF(value)")
                    font-awesome-icon.mr-1(icon="file-download")
                    | PDF herunterladen

        .col
            .card.h-100
                .card-body(v-if="userRole === 'user'")
                    p Sind alle Eingaben gemacht und beide Schutzziele erreicht, können Sie die Berechnung nun zur Freigabe vorlegen.
                    button.btn.btn-primary(@click="setProtocolStatus('pending')")
                        font-awesome-icon.mr-1(icon="share")
                        | Zur Freigabe vorlegen

                .card-body(v-else)
                    p Wenn Sie das fertige Protokoll heruntergeladen haben, können Sie die Berechnung als "Abgeschlossen" markieren.
                    button.btn.btn-primary(@click="setProtocolStatus('closed')")
                        font-awesome-icon.mr-1(icon="share")
                        | Protokoll abschließen

    .mt-4
        p
            | Vergessen Sie nicht Ihre Anmerkungen für das erstellte Protokoll separat festzuhalten.
            br
            | Prüfen Sie das Protokoll auf Richtigkeit und ob alle Ihre Eingaben gespeichert und übernommen wurden.
</template>

<script>
import api from '@/utils/api'
import { openPDF, downloadPDF } from '@/utils/pdf'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faShare, faExternalLinkAlt, faFileDownload, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { Protocol } from 'trgi'

library.add(faShare, faExternalLinkAlt, faFileDownload, faInfoCircle)

export default {
    props: {
        value: {
            type: Protocol,
            validator: function (value) {
                // TODO: define minimum requirements for Schutzziel2 Tab to show up
                return value.data.rooms.length >= 1
            },
            default: function () {
                return new Protocol()
            }
        }
    },
    computed: {
        commonGotchas () {
            let gotchas = []
            // got ALDs but no qAld was set
            if (!this.value.data.qAld && this.value.data.rooms.find(room => room.numAld > 0)) {
                gotchas.push('Sie haben im Tab "Schutzziel 2" ALDs für einen oder mehrere Räume definiert, aber keinen Herstellerwert angegeben.')
            }
            // less than 3 rooms
            if (this.value.data.rooms.length < 3) {
                gotchas.push('Sie haben weniger als 3 Räume angegeben.')
            }
            // no fireplace
            if (!this.value.data.rooms[0].fireplaces.length) {
                gotchas.push('Sie haben im Aufstellraum (=erster Raum) keine Feuerstätte angegeben.')
            }
            return gotchas
        },
        userRole () {
            return this.$store.getters.userRole
        }
    },
    methods: {
        openPDF,
        downloadPDF,
        async setProtocolStatus (status) {
            try {
                await api.post(`/protocols/${this.value.id}`, { status })
                this.$store.dispatch('alert/success', 'Protokoll Status aktualisiert')
            } catch (err) {
                this.$store.dispatch('alert/error', 'Protokoll Status konnte nicht aktualisiert werden')
            }
        }
    }
}
</script>
